import { Component, OnInit } from '@angular/core';
import { TableAgent } from '../../../../data/schemas/table.schema';
import { routeAlias } from '../../../../../routesalias';
import { RouterLink } from '@angular/router';
import { AgentService } from '../../../../services/agent.service';
import { AppService } from '../../../../core/app.service';
import { AgentRes } from '../../../../data/http/responses/agent.res';
import { UiTable } from "../../../../components/ui/table/table.component";
import { UiButtonComponent } from '../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-agent',
  standalone: true,
  imports: [UiTable, RouterLink, UiButtonComponent, loaderIntervantion, ConfirmDialogComponent],
  templateUrl: './agent.component.html',
  styleUrl: './agent.component.css'
})
export class AgentPage implements OnInit {
  public tableEntities = TableAgent;
  public entities: AgentRes[] = [];
  public routeAlias = routeAlias;
  public isLoading = false;

  public showDeleteConfirm = false;
  public selectedItem: AgentRes | null = null;
  public deleteLoading = false;

  constructor(private entityService: AgentService, private appService: AppService) {}

  ngOnInit(): void { this.loadEntities(); }

  loadEntities(): void {
    this.isLoading = true;
    this.entityService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (r: any) => { this.entities = r.data; this.isLoading = false; },
      error: (e) => { console.error(e); this.isLoading = false; }
    });
  }

  openDeleteConfirm(item: AgentRes): void { this.selectedItem = item; this.showDeleteConfirm = true; }
  cancelDelete(): void { this.showDeleteConfirm = false; this.selectedItem = null; }
  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.entityService.delete(this.selectedItem.id).subscribe({
      next: () => { this.loadEntities(); this.deleteLoading = false; this.cancelDelete(); },
      error: (e) => { console.error(e); this.deleteLoading = false; }
    });
  }
}